import React, { useState, useEffect } from 'react';
import { agentsAPI, kycAPI } from '../services/api';
// ...existing code...
import './ManagementPages.css';

const AgentsPage = () => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showPanModal, setShowPanModal] = useState(false);
  const [showAadhaarModal, setShowAadhaarModal] = useState(false);
  const [kycLoading, setKycLoading] = useState(false);
  const [kycError, setKycError] = useState(null);
  const [kycSuccess, setKycSuccess] = useState(null);
  const [panInput, setPanInput] = useState('');
  const [aadhaarInput, setAadhaarInput] = useState('');
  const [aadhaarOtp, setAadhaarOtp] = useState('');
  const [aadhaarRefId, setAadhaarRefId] = useState(null);
  const [inlineVerification, setInlineVerification] = useState({ pan: false, aadhaar: false });
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    employeeId: '',
    region: '',
    panNumber: '',
    aadhaarNumber: '',
  });

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await agentsAPI.getAgents();
      const list = data && (Array.isArray(data) ? data : data.data || []) || [];
      // Normalize KYC fields (different API shapes)
      const normalized = list.map(a => ({
        ...a,
        pan_number: a.pan_number ?? a.panNumber ?? a.pan_no ?? null,
        aadhaar_number: a.aadhaar_number ?? a.aadhaarNumber ?? a.aadhar ?? null,
        pan_verified: !!(a.pan_verified ?? a.panVerified ?? a.pan_verified_flag),
        aadhaar_verified: !!(a.aadhaar_verified ?? a.aadhaarVerified ?? a.aadhar_verified),
      }));
      setAgents(normalized);
    } catch (err) {
      setError(err.message || 'Failed to load agents');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleInlinePanVerify = async () => {
    const pan = (formData.panNumber || '').toUpperCase();
    setKycError(null);
    setKycSuccess(null);
    
    if (inlineVerification.pan || (selectedAgent && selectedAgent.pan_verified)) {
      setKycSuccess('PAN is already verified ✓');
      return;
    }
    if (!pan || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      setKycError('Enter valid PAN (e.g., ABCDE1234F)');
      return;
    }
    try {
      setKycLoading(true);
      console.log('Calling PAN verify API for:', pan);
      const response = await kycAPI.verifyPan(pan);
      console.log('PAN Verify Full Response:', response);
      const result = response?.data || response;
      
      // Check for successful verification
      if (result && (result.verified || result.success || result.panNo || result.registeredName)) {
        setInlineVerification(prev => ({ ...prev, pan: true }));
        setKycSuccess(`PAN Verified Successfully: ${result.registeredName || pan} ✓`);
        
        if (selectedAgent && selectedAgent.id) {
          try {
            await agentsAPI.updateKycStatus(selectedAgent.id, { panVerified: true });
            setSelectedAgent(prev => prev ? { ...prev, pan_verified: true } : prev);
          } catch (e) {
            console.error('Failed to update KYC status:', e);
          }
        }
        fetchAgents();
      } else {
        throw new Error(result?.message || 'PAN verification failed');
      }
    } catch (err) {
      console.error('PAN verification error:', err);
      // Extract error message from different possible formats
      const errorMsg = err?.data?.message || err?.data?.error || err?.message || 'PAN verification failed. Please check console for details.';
      setKycError(errorMsg);
    } finally {
      setKycLoading(false);
    }
  };

  const handleInlineAadhaarVerify = async () => {
    const aadhaar = (formData.aadhaarNumber || '').replace(/\s/g, '');
    setKycError(null);
    setKycSuccess(null);
    
    if (inlineVerification.aadhaar || (selectedAgent && selectedAgent.aadhaar_verified)) {
      setKycSuccess('Aadhaar is already verified ✓');
      return;
    }
    if (!aadhaar || !/^\d{12}$/.test(aadhaar)) {
      setKycError('Enter valid 12-digit Aadhaar');
      return;
    }
    try {
      setKycLoading(true);
      const resp = await kycAPI.sendAadhaarOtp(aadhaar);
      const data = resp?.data || resp;
      const refId = data?.refId || data?.ref_id;
      if (!refId) throw new Error(data?.message || 'Failed to send OTP');
      
      setKycSuccess('OTP sent! Check your Aadhaar-linked mobile.');
      const otp = window.prompt('Enter 6-digit Aadhaar OTP sent to your mobile:');
      if (!otp || !/^\d{6}$/.test(otp)) {
        setKycError('Invalid OTP. Please try again.');
        setKycSuccess(null);
        return;
      }
      
      const verifyResp = await kycAPI.verifyAadhaarOtp(aadhaar, otp, refId);
      const verifyData = verifyResp?.data || verifyResp;
      console.log('Aadhaar Verify Response:', verifyData);
      
      if (verifyData && (verifyData.verified || verifyData.success || verifyData.aadhar)) {
        setInlineVerification(prev => ({ ...prev, aadhaar: true }));
        setKycSuccess('Aadhaar Verified Successfully ✓');
        
        if (selectedAgent && selectedAgent.id) {
          try {
            await agentsAPI.updateKycStatus(selectedAgent.id, { aadhaarVerified: true });
            setSelectedAgent(prev => prev ? { ...prev, aadhaar_verified: true } : prev);
          } catch (e) {
            console.error('Failed to update KYC status:', e);
          }
        }
        fetchAgents();
      } else {
        throw new Error(verifyData?.message || 'Aadhaar verification failed');
      }
    } catch (err) {
      setKycError(err.message || 'Aadhaar verification failed');
    } finally {
      setKycLoading(false);
    }
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Client-side validation
    const validateForm = () => {
      if (!formData.firstName) return 'First name is required';
      if (!formData.lastName) return 'Last name is required';
      if (!formData.email || !formData.email.includes('@')) return 'Enter a valid email address';
      const phoneClean = (formData.phone || '').replace(/\D/g, '');
      if (!phoneClean || phoneClean.length !== 10) return 'Enter a valid 10-digit phone number';
      if (!selectedAgent && !formData.password) return 'Password is required for new agents';
      if (!formData.employeeId && formData.employeeId !== '') {
        // ok optional
      }
      // PAN validation
      if (!formData.panNumber || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test((formData.panNumber || '').toUpperCase())) return 'Enter valid PAN (e.g., ABCDE1234F)';
      // Aadhaar validation
      if (!formData.aadhaarNumber || !/^\d{12}$/.test((formData.aadhaarNumber || '').replace(/\s/g, ''))) return 'Enter valid 12-digit Aadhaar';
      // If creating, ensure verified flags (UI enforces this but give clear message)
      if (!selectedAgent && (!(inlineVerification.pan) || !(inlineVerification.aadhaar))) return 'Please verify PAN and Aadhaar before creating an agent';
      return null;
    };

    const clientError = validateForm();
    if (clientError) {
      setKycError(clientError);
      return;
    }

    try {
      if (selectedAgent) {
        const payload = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          phone: formData.phone,
          employeeId: formData.employeeId,
          region: formData.region,
          panNumber: formData.panNumber,
          aadhaarNumber: formData.aadhaarNumber,
        };
        await agentsAPI.updateAgent(selectedAgent.id, payload);
        alert('Agent updated successfully');
      } else {
        const payload = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
          employeeId: formData.employeeId,
          region: formData.region,
          panNumber: formData.panNumber,
          aadhaarNumber: formData.aadhaarNumber,
        };
        await agentsAPI.createAgent(payload);
        alert('Agent created successfully');
      }
      setShowForm(false);
      setSelectedAgent(null);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        employeeId: '',
        region: '',
        panNumber: '',
        aadhaarNumber: '',
      });
      fetchAgents();
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  const handleEdit = (agent) => {
    setSelectedAgent(agent);
    setFormData({
      firstName: agent.first_name,
      lastName: agent.last_name,
      email: agent.email,
      phone: agent.phone,
      password: '', // Don't pre-fill password
      employeeId: agent.employee_id || '',
      region: agent.region || '',
      panNumber: agent.pan_number || '',
      aadhaarNumber: agent.aadhaar_number || '',
    });
    // reflect verified flags in the inline verification state
    setInlineVerification({ pan: !!agent.pan_verified, aadhaar: !!agent.aadhaar_verified });
    setKycError(null);
    setKycSuccess(null);
    setShowForm(true);
  };

  const openPanVerify = (agent) => {
    setSelectedAgent(agent);
    setPanInput(agent.first_name ? (agent.pan_number || '') : '');
    setKycError(null);
    setShowPanModal(true);
  };

  const handlePanVerify = async () => {
    if (!panInput || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panInput)) {
      setKycError('Enter valid PAN (e.g., ABCDE1234F)');
      return;
    }
    try {
      setKycLoading(true);
      setKycError(null);
      await kycAPI.verifyPan(panInput);
      // If verification successful, update agent KYC flag
      await agentsAPI.updateKycStatus(selectedAgent.id, { panVerified: true });
      alert('PAN verified and flag updated');
      setShowPanModal(false);
      fetchAgents();
    } catch (err) {
      setKycError(err.message || 'PAN verification failed');
    } finally {
      setKycLoading(false);
    }
  };

  const openAadhaarVerify = (agent) => {
    setSelectedAgent(agent);
    setAadhaarInput(agent.aadhaar_number || '');
    setAadhaarOtp('');
    setAadhaarRefId(null);
    setKycError(null);
    setShowAadhaarModal(true);
  };

  const handleAadhaarSendOtp = async () => {
    if (!aadhaarInput || !/^\d{12}$/.test(aadhaarInput.replace(/\s/g, ''))) {
      setKycError('Enter valid 12-digit Aadhaar');
      return;
    }
    try {
      setKycLoading(true);
      setKycError(null);
      const resp = await kycAPI.sendAadhaarOtp(aadhaarInput.replace(/\s/g, ''));
      const data = resp.data || resp;
      setAadhaarRefId(data.refId || data.ref_id || null);
    } catch (err) {
      setKycError(err.message || 'Failed to send OTP');
    } finally {
      setKycLoading(false);
    }
  };

  const handleAadhaarVerifyOtp = async () => {
    if (!aadhaarOtp || !/^\d{6}$/.test(aadhaarOtp)) {
      setKycError('Enter valid 6-digit OTP');
      return;
    }
    try {
      setKycLoading(true);
      setKycError(null);
      await kycAPI.verifyAadhaarOtp(aadhaarInput.replace(/\s/g, ''), aadhaarOtp, aadhaarRefId);
      await agentsAPI.updateKycStatus(selectedAgent.id, { aadhaarVerified: true });
      alert('Aadhaar verified and flag updated');
      setShowAadhaarModal(false);
      fetchAgents();
    } catch (err) {
      setKycError(err.message || 'OTP verification failed');
    } finally {
      setKycLoading(false);
    }
  };

  const handleDelete = async (agentId) => {
    if (window.confirm('Are you sure you want to delete this agent?')) {
      try {
        await agentsAPI.deleteAgent(agentId);
        fetchAgents();
      } catch (err) {
        alert('Error deleting agent: ' + err.message);
      }
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Agents Management</h1>
        <p>Manage all loan distribution agents</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <button
          className="button button-primary"
          onClick={() => {
            setShowForm(true);
            setSelectedAgent(null);
            setFormData({
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              password: '',
              employeeId: '',
              region: '',
              panNumber: '',
              aadhaarNumber: '',
            });
            setInlineVerification({ pan: false, aadhaar: false });
            setKycError(null);
            setKycSuccess(null);
          }}
        >
          Add New Agent
        </button>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div className="loader"></div>
      ) : agents.length > 0 ? (
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Employee ID</th>
                <th>Region</th>
                <th>Retailers</th>
                <th>Active Loans</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {agents.map((agent) => (
                <tr key={agent.id}>
                  <td>
                    <div>{agent.first_name} {agent.last_name}</div>
                    <div className="kyc-badges">
                      {agent.pan_verified && (
                        <span className="kyc-item">PAN ✓</span>
                      )}
                      {agent.aadhaar_verified && (
                        <span className="kyc-item">AADHAAR ✓</span>
                      )}
                    </div>
                  </td>
                  <td>{agent.email}</td>
                  <td>{agent.phone}</td>
                  <td>{agent.employee_id}</td>
                  <td>{agent.region}</td>
                  <td>{agent.retailer_count || 0}</td>
                  <td>{agent.loan_count || 0}</td>
                  <td>
                    <span className={`badge badge-${agent.is_active ? 'active' : 'inactive'}`}>
                      {agent.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    {agent.pan_verified && agent.aadhaar_verified && (
                      <span className="badge badge-verified" style={{ marginRight: 8 }}>VERIFIED</span>
                    )}
                    <button className="action-btn edit-btn" onClick={() => handleEdit(agent)}>Edit</button>
                    <button className="action-btn delete-btn" onClick={() => handleDelete(agent.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="no-data">No agents found</div>
      )}

      {showForm && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>{selectedAgent ? 'Edit Agent' : 'Add New Agent'}</h2>
              <button
                className="close-btn"
                onClick={() => {
                  setShowForm(false);
                  setSelectedAgent(null);
                }}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {kycError && <div className="alert alert-error">{kycError}</div>}
              {kycSuccess && <div className="alert alert-success">{kycSuccess}</div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                {!selectedAgent && (
                  <div className="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      required={!selectedAgent}
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Employee ID (Optional)</label>
                  <input
                    type="text"
                    name="employeeId"
                    value={formData.employeeId}
                    onChange={handleInputChange}
                    placeholder="Leave blank to auto-generate"
                  />
                </div>
                <div className="form-group">
                  <label>Region</label>
                  <input
                    type="text"
                    name="region"
                    value={formData.region}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group kyc-row">
                  <div className="kyc-input">
                    <label>PAN Number</label>
                    <input
                      type="text"
                      name="panNumber"
                      value={(formData.panNumber || '').toUpperCase()}
                      onChange={handleInputChange}
                      placeholder="ABCDE1234F"
                      required
                    />
                  </div>
                  <div className="kyc-action">
                    <button
                      type="button"
                      className={`button button-small ${ (inlineVerification.pan || (selectedAgent && selectedAgent.pan_verified)) ? 'verified-badge' : 'button-secondary' } ${kycLoading ? 'verify-disabled' : ''}`}
                      onClick={handleInlinePanVerify}
                      disabled={kycLoading || !(formData.panNumber && formData.panNumber.length >= 10) || (inlineVerification.pan || (selectedAgent && selectedAgent.pan_verified))}
                    >
                      {(inlineVerification.pan || (selectedAgent && selectedAgent.pan_verified)) ? '✓ Verified' : 'Verify'}
                    </button>
                  </div>
                </div>
                <div className="form-group kyc-row">
                  <div className="kyc-input">
                    <label>Aadhaar Number</label>
                    <input
                      type="text"
                      name="aadhaarNumber"
                      value={formData.aadhaarNumber || ''}
                      onChange={handleInputChange}
                      placeholder="12-digit Aadhaar"
                      required
                    />
                  </div>
                  <div className="kyc-action">
                    <button
                      type="button"
                      className={`button button-small ${ (inlineVerification.aadhaar || (selectedAgent && selectedAgent.aadhaar_verified)) ? 'verified-badge' : 'button-secondary' } ${kycLoading ? 'verify-disabled' : ''}`}
                      onClick={handleInlineAadhaarVerify}
                      disabled={kycLoading || !(formData.aadhaarNumber && formData.aadhaarNumber.replace(/\s/g,'').length === 12) || (inlineVerification.aadhaar || (selectedAgent && selectedAgent.aadhaar_verified))}
                    >
                      {(inlineVerification.aadhaar || (selectedAgent && selectedAgent.aadhaar_verified)) ? '✓ Verified' : 'Verify'}
                    </button>
                  </div>
                </div>
                <div className="form-actions">
                  <button type="submit" className="button button-primary">
                    {selectedAgent ? 'Update' : 'Create'} Agent
                  </button>
                  <button
                    type="button"
                    className="button button-secondary"
                    onClick={() => {
                      setShowForm(false);
                      setSelectedAgent(null);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* PAN Verification Modal */}
      {showPanModal && (
        <div className="modal-overlay" onClick={() => setShowPanModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Verify PAN</h2>
              <button className="close-btn" onClick={() => setShowPanModal(false)}>×</button>
            </div>
            <div className="modal-body">
              {kycError && <div className="alert alert-error">{kycError}</div>}
              <div className="form-group">
                <label>PAN</label>
                <input type="text" value={panInput} onChange={(e) => setPanInput(e.target.value.toUpperCase().slice(0,10))} placeholder="ABCDE1234F" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="button button-secondary" onClick={() => setShowPanModal(false)}>Cancel</button>
              <button className="button button-primary" onClick={handlePanVerify} disabled={kycLoading}>{kycLoading ? 'Processing...' : 'Verify PAN'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Aadhaar Verification Modal */}
      {showAadhaarModal && (
        <div className="modal-overlay" onClick={() => setShowAadhaarModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Verify Aadhaar</h2>
              <button className="close-btn" onClick={() => setShowAadhaarModal(false)}>×</button>
            </div>
            <div className="modal-body">
              {kycError && <div className="alert alert-error">{kycError}</div>}
              <div className="form-group">
                <label>Aadhaar Number</label>
                <input type="text" value={aadhaarInput} onChange={(e) => setAadhaarInput(e.target.value.replace(/\D/g, '').slice(0,12))} placeholder="12-digit Aadhaar" />
              </div>
              {aadhaarRefId ? (
                <div className="form-group">
                  <label>OTP</label>
                  <input type="text" value={aadhaarOtp} onChange={(e) => setAadhaarOtp(e.target.value.replace(/\D/g, '').slice(0,6))} placeholder="6-digit OTP" />
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              <button className="button button-secondary" onClick={() => setShowAadhaarModal(false)}>Cancel</button>
              {!aadhaarRefId ? (
                <button className="button button-primary" onClick={handleAadhaarSendOtp} disabled={kycLoading}>{kycLoading ? 'Sending...' : 'Send OTP'}</button>
              ) : (
                <button className="button button-primary" onClick={handleAadhaarVerifyOtp} disabled={kycLoading}>{kycLoading ? 'Verifying...' : 'Verify OTP'}</button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentsPage;
